export const LOG_LEVELS = {
  test: 0,
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  fatal: 6,
  off: 7,
} as const;

export type LogLevel = keyof typeof LOG_LEVELS;
export type LogTransport = (level: LogLevel, context: string, message: string, data?: unknown) => void;

export interface ILogger {
  level: LogLevel;
  setLevel(level: LogLevel): void;
  addTransport(t: LogTransport): void;
  removeTransport(t: LogTransport): void;
  log(level: LogLevel, message: string, data?: unknown): void;
  test(msg: string, data?: unknown): void;
  trace(msg: string, data?: unknown): void;
  debug(msg: string, data?: unknown): void;
  info(msg: string, data?: unknown): void;
  warn(msg: string, data?: unknown): void;
  error(msg: string, data?: unknown): void;
  fatal(msg: string, data?: unknown): void;
}
